import Box from 'ui/Box';
import { isKiosk } from 'utils/platform';

/**
 * This component is used to add padding to the top of the InteriorSuggestionsMenu
 * to misalign the product list items with the screen. Misaligned products makes it
 * clearer that the product list is scrollable.
 * @returns {JSX.Element} The InteriorSuggestionsMenuPadding component
 */
export const InteriorSuggestionsMenuPadding = () => {
  if (!isKiosk()) {
    return <></>;
  }

  return <Box pt="l"></Box>;
};
